import type { SessionUser } from "./session";

/** Whether the user can make sign-off decisions (accept / request changes /
 * reopen / archive). The single source of truth for the reviewer permission. */
export function canDecide(user: SessionUser): boolean {
  return user.role === "admin" || user.role === "product_owner";
}

/** Admin-only capabilities (settings, space switch, inviting users). */
export function isAdmin(user: SessionUser): boolean {
  return user.role === "admin";
}

/** Whether the user can set a task's review-priority flag — the dev/admin triage
 * signal (admins + developers, not product owners or viewers). */
export function canPrioritize(user: SessionUser): boolean {
  return user.role === "admin" || user.role === "developer";
}
